import React from 'react';

import { Box } from '@rbilabs/universal-components';

import { Typography } from 'components/ui';
import { getDesignToken } from 'styles/constants';
const Wrapper = Box.withConfig({
  marginTop: '$6',
  marginBottom: '$4',
  borderBottomWidth: 1,
  borderColor: getDesignToken('border-color-default'),
});

export const TableHeader = ({ title, testID }: { title: string; testID?: string }) => {
  return (
    <Wrapper testID={testID}>
      <Typography variant="headerThree" mb="$1" focusable>
        {title}
      </Typography>
    </Wrapper>
  );
};
